import { gql } from "@outschool/ui-apollo";

export const meetingReviewMutation = gql`
  mutation MeetingReviewMutation(
    $sectionUid: ID!
    $rating: Int!
    $type: MeetingReviewType!
  ) {
    createMeetingReview(sectionUid: $sectionUid, rating: $rating, type: $type) {
      uid
      learnerUid
      rating
      meetingUid
      sectionUid
      type
    }
  }
`;
